import { render, staticRenderFns } from "./PlacetopayPaymentDetailModal.vue?vue&type=template&id=794f427a"
import script from "./PlacetopayPaymentDetailModal.vue?vue&type=script&lang=js"
export * from "./PlacetopayPaymentDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports